import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { push } from 'connected-react-router';

import { withIntl } from 'HOC/withIntl';
import shouldSubmit from 'utilities/shouldSubmit';
import generateInitialLanguageValues from 'utilities/generateInitialLanguageValues';
import getDefaultLanguageRequiredFieldsErrors from 'utilities/getDefaultLanguageRequiredFieldsErrors';
import config from 'config/index';

import AddPinForm from '../components/PinForm';

import { addPinRequest } from '../services/actions';
import { forms, requiredFields, localizableFields, defaultValues } from '../services/config';

const form = forms.addPinForm;
const initialLangValues = generateInitialLanguageValues();

const validate = (values, { intl }) =>
    getDefaultLanguageRequiredFieldsErrors(values, requiredFields, intl.formatMessage({ id: 'error.required' }));

const onSubmit = (data, dispatch, { intl }) => {
    const confirmMessage = intl.formatMessage({ id: 'alert.submit.warn' });
    if (shouldSubmit(data, localizableFields, confirmMessage)) {
        dispatch(addPinRequest(form, data));
    }
};

export default compose(
    withIntl,
    connect(null, dispatch => ({
        cancel: () => {
            dispatch(push(config.routes.pins));
        },
    })),
    reduxForm({
        initialValues: {
            ...initialLangValues,
            ...defaultValues,
        },
        form,
        validate,
        onSubmit,
        enableReinitialize: true,
    }),
)(AddPinForm);
